import { createContext } from "react";

export const JobModalContext = createContext({
  jobId: null,
  workflowGroupId: null,
});
